import { render, staticRenderFns } from "./modal_position.vue?vue&type=template&id=52297d4a&scoped=true"
import script from "./modal_position.vue?vue&type=script&lang=js"
export * from "./modal_position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52297d4a",
  null
  
)

export default component.exports